// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-14T15:27:30.049Z
// Property: 110 Royy (ID: 6767906449166921)
// Collections: 28 amenities, 10 floorplans (live), 11 photos, 47 POIs, 2 reviews, 2 virtual tours, 7 office hours, 1 special offers (live), 3 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449166921",
  "property_external_id": "swv1xf7",
  "property_zillow_url": "https://www.zillow.com/apartments/seattle-wa/110-roy-apartments/CkBVR2/",
  "property_apartments_url": "https://www.apartments.com/110-roy-apartments-seattle-wa/swv1xf7/",
  "property_google_business_url": "https://www.google.com/maps/place/110+Roy+Apartments/data=!4m2!3m1!1s0x0:0x487533098f962edd?sa=X&ved=2ahUKEwjfmcie0LiSAxXdTTABHR5MApMQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "110-roy",
  "property_name": "110 Royy",
  "property_website_url": "https://www.110roy.com/",
  "property_domain": null,
  "property_address": "110 Roy Street",
  "property_full_address": "110 Roy St, Seattle, WA 98109, USA",
  "property_address_1": "110 Roy Street",
  "property_address_2": null,
  "property_address_city": "Seattle",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98109",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Uptown",
  "property_address_latitude": "47.62566",
  "property_address_longitude": "-122.3548387",
  "property_email": null,
  "property_phone": "(425) 517-3203",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Your front row to Uptown Seattle.</strong> Find light-filled apartments with chef-style finishes, smart-lock entry, in-home laundry, and skyline views from the rooftop Skyview Terrace—then <strong>schedule your tour</strong> of 110 Royy today.</p>",
  "property_long_description": "<p><strong>Your front row to Uptown Seattle.</strong> At 110 Royy, city energy and skyline calm meet blocks from Seattle Center, Climate Pledge Arena, the Space Needle, McCaw Hall, MoPOP, and the Monorail to downtown. Step out for Queen Anne dining and nightlife, bike or stroll toward the Elliott Bay waterfront and Myrtle Edwards Park, or make quick connections to South Lake Union and downtown.</p><p>Inside, choose from <a href=\"/floor-plans\">studio, open one-bedroom, one-bedroom with den, and two-bedroom layouts</a> designed with air conditioning, wide light-filled windows, hardwood-style plank flooring, smart-lock entry, front-loading laundry, and chef-style kitchens with quartz slab counters, stainless-steel appliances, full-height tile backsplash, and pull-out faucets. Above it all, the rooftop Skyview Terrace brings Space Needle and Seattle skyline views together with grilling, fire-pit, lounge, and pet areas, while the <a href=\"/amenities\">community amenities</a> add a 24-hour fitness studio, resident lounge with work spaces, package lockers, bike storage with repair station, EV charging, and a self-service Pet Spaw.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-7d91-71e1-8c35-d0eb1f29eb4a.webp",
  "property_featured_image_media": {
    "alt_text": "Rooftop deck with seating, tables, and city views.",
    "public_id": "019cfde4-7d91-71e1-8c35-d0eb1f29eb4a",
    "storage_key": "property/6767906449166921/019cfde4-7d91-71e1-8c35-d0eb1f29eb4a.webp",
    "width": 1024,
    "height": 767
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166921/019f6606-9d75-7009-b10c-8fc348a4d613.mp4",
  "property_featured_video_media": {
    "public_id": "019f6606-9d75-7009-b10c-8fc348a4d613",
    "storage_key": "property/6767906449166921/019f6606-9d75-7009-b10c-8fc348a4d613.mp4",
    "thumbnail_key": "property/6767906449166921/019f6606-9d75-7009-b10c-8fc348a4d613_thumb.webp",
    "size_bytes": 647607,
    "classification": "Other",
    "title": "Rick Astley - Never Gonna Give You Up",
    "description": "The official music video for Rick Astley's 1987 hit single 'Never Gonna Give You Up'."
  },
  "property_total_units": "167",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": "96",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.22155688622755",
  "property_admin_fee": "1",
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "600",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats allowed, maximum 2 pets per unit.",
  "property_pet_policy_description": "Dogs and cats allowed, maximum 2 pets per unit. Pet deposit: $300 per pet. Monthly pet rent: $50 per pet.",
  "property_petpolicy_info": "This is a pet blurb!",
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-6f6d-731c-81fa-0f26051bcaed.webp",
  "property_primary_logo_media": {
    "alt_text": "110 Roy Queen Anne logo",
    "public_id": "019cfde2-6f6d-731c-81fa-0f26051bcaed",
    "storage_key": "property/6767906449166921/019cfde2-6f6d-731c-81fa-0f26051bcaed.webp",
    "width": 251,
    "height": 145
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-706e-739b-be58-0c990844bf46.webp",
  "property_secondary_logo_media": {
    "alt_text": "110 Roy Queen Anne logo",
    "public_id": "019cfde2-706e-739b-be58-0c990844bf46",
    "storage_key": "property/6767906449166921/019cfde2-706e-739b-be58-0c990844bf46.webp",
    "width": 1920,
    "height": 1118
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-3eb8-7346-bec0-2afed7543b1e.webp",
  "property_fav_icon_media": {
    "alt_text": "110 Roy Queen Anne logo",
    "public_id": "019cfde5-3eb8-7346-bec0-2afed7543b1e",
    "storage_key": "property/6767906449166921/019cfde5-3eb8-7346-bec0-2afed7543b1e.webp",
    "width": 251,
    "height": 145
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03e47-a55a-760d-b07e-7e8ddf97a2b7.webp",
  "property_mono_white_logo_media": {
    "alt_text": "110 Roy Queen Anne logo",
    "public_id": "01a03e47-a55a-760d-b07e-7e8ddf97a2b7",
    "storage_key": "property/6767906449166921/01a03e47-a55a-760d-b07e-7e8ddf97a2b7.webp",
    "width": 251,
    "height": 145
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03e47-99d2-7630-ba77-c4bf89468c28.webp",
  "property_mono_black_logo_media": {
    "alt_text": "110 Roy Queen Anne logo",
    "public_id": "01a03e47-99d2-7630-ba77-c4bf89468c28",
    "storage_key": "property/6767906449166921/01a03e47-99d2-7630-ba77-c4bf89468c28.webp",
    "width": 251,
    "height": 145
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#fbff00",
  "property_secondary_color": "#fff700",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "513 - 1,039 sq ft",
  "property_sqft_min": "513",
  "property_sqft_max": "1,039",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/456172570912353",
  "property_instagram_url": "https://www.instagram.com/p/DTDs3XeDxUi/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJKUuOhjwVkFQR3S6WjwkzdUg",
  "property_youtube_url": "https://www.youtube.com/@110Roy_Dyverse",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Queen+Anne+Apartments&find_loc=Seattle%2C+WA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 110 Roy",
  "property_home_romance_title": "Embrace Life and Love in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Amenities designed for everyday ease.</strong> At 110 Royy, thoughtful community features and comfortable spaces come together to support a streamlined Seattle living experience. Explore the full amenities list to see what sets the property apart.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans that work beautifully.</strong> Choose from smart studios, one-bedroom layouts, a den option, and a two-bedroom, two-bath home at 110 Royy—each shaped for light, storage, and easy everyday flow in Uptown Seattle. Expect air conditioning, front-loading laundry, smart-lock entry, hardwood-style plank flooring, and chef-style kitchens with quartz countertops and stainless-steel appliances. Select homes add private outdoor space, extra-high ceilings, or skyline outlooks.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the view from 110 Royy.</strong> Flip through bright interiors with quartz chef-style kitchens, stainless-steel appliances, plank flooring, and oversized windows, then head up to the Skyview Terrace for lounge seating, grills, a fire pit, and wide Uptown Seattle views. The gallery also spotlights the resident lounge, fitness studio, bike spaces, and pet-friendly touches that bring the community into focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Uptown starts right outside 110 Royy.</strong> Step out for Roy Street dining, pre-show drinks, and Seattle Center’s nonstop lineup—from KEXP and McCaw Hall to MoPOP, Chihuly Garden and Glass, and Climate Pledge Arena. Pizza at The Masonry, oysters at Taylor Shellfish, Elliott Bay air at Myrtle Edwards Park, and quick Monorail access to Westlake keep the neighborhood easy to explore.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews point to service that stands out.</strong> Residents highlight quick communication, attentive leasing support, and responsive maintenance, with one noting, “It is the team that really shines.” Add in a well-kept community, a walkable Uptown setting, and everyday convenience, and the feedback paints a clear picture of connected, easy living at 110 Royy.</p>",
  "property_neighborhood_blurb": "<p><strong>Step into Uptown’s everyday rhythm.</strong> From 110 Royy, your map starts with Roy Street restaurants, pre-show bites, and late-night energy, then expands into Seattle Center’s arts-and-event campus, where KEXP, McCaw Hall, MoPOP, Chihuly Garden and Glass, and Climate Pledge Arena keep the calendar moving. Grab wood-fired pizza at The Masonry, oysters at Taylor Shellfish, or a casual round at Queen Anne Beerhall, then trade city lights for Elliott Bay air along the Seattle Center-to-Waterfront walking and biking connection and Myrtle Edwards Park. The Monorail links Seattle Center with Westlake for downtown plans, while nearby bus routes connect you with South Lake Union, Belltown, and Queen Anne Hill. See the setting, then <a href=\"/schedule-a-tour\">schedule a tour</a> to explore life in the middle of it.</p>",
  "property_accessibility_blurb": "<p>test</p>",
  "property_amenities_blurb": "<p>foo bar</p>",
  "property_applynow_blurb": "<p><strong>Ready to make 110 Royy home?</strong> Start your application online for a light-filled Uptown Seattle apartment with air conditioning, smart-lock entry, in-home laundry, and chef-style finishes—plus rooftop skyline views and everyday conveniences that keep city living effortless.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Connect with the 110 Royy leasing team for details on available layouts, rooftop Skyview Terrace, community amenities, or directions to our Uptown Seattle address. Reach out today and get one step closer to your front row to the city.</p>",
  "property_faqs_blurb": "<p><strong>Questions about 110 Royy?</strong> Start here for quick answers about leasing, apartment layouts, amenities, and everyday living in Uptown Seattle. If you don’t see what you need, the leasing team is happy to help with details, tours, and next steps.</p>",
  "property_floorplans_blurb": "<p><strong>Find your best fit at 110 Royy.</strong> Compare efficient studios, open one-bedroom layouts, defined one-bedroom homes, a den option, and a two-bedroom, two-bath residence—all designed to make the most of light, storage, and everyday flow in Uptown Seattle.</p><p>Inside, thoughtful details elevate each plan: air conditioning, front-loading laundry, hardwood-style plank flooring, smart-lock entry, and chef-style kitchens with quartz slab countertops, stainless-steel appliances, full-height tile backsplash, and pull-out faucets. Select homes add private outdoor space, extra-high ceilings, or skyline outlooks for an added sense of openness. Use the floor plan cards below to review layouts, pricing, and availability, then explore more <a href=\"/amenities\">apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorites in person.</p>",
  "property_gallery_blurb": "<p><strong>See 110 Royy from every angle.</strong> Browse photos that move from bright apartment interiors to the rooftop Skyview Terrace, where lounge seating, grills, and a fire pit frame wide views over Uptown Seattle. Inside, notice chef-style kitchens with quartz counters, stainless-steel appliances, and full-height tile backsplashes, plus plank flooring and oversized windows that keep each home feeling open and polished. The gallery also captures the places that extend your day beyond your front door: a resident lounge with work nooks and billiards, a 24-hour fitness studio, bike-friendly spaces, and thoughtful pet amenities. Like what you see? Compare <a href=\"/floor-plans\">available layouts</a>, explore more <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the views, finishes, and shared spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore your front row to Uptown Seattle.</strong><br>Use the interactive map to browse available apartments at 110 Royy and see how close home is to skyline views, waterfront strolls, Queen Anne dining, downtown connections, and the city energy surrounding Seattle Center.</p>",
  "property_pets_blurb": "<p><strong>Pet care, built into your routine.</strong> At 110 Royy, your dog or cat has more than a place to live—daily care is easier with a designated rooftop pet area and a self-service Pet Spaw right at home. Step out for a quick break, rinse off after a rainy walk, or keep grooming day simple without leaving the building.</p><p>When it’s time to stretch your legs, Uptown puts fresh-air options within reach, from waterfront paths at Myrtle Edwards Park to the nearby Kinnear Park off-leash area. Back home, skyline views, lounge spaces, bike storage, and other <a href=\"/amenities\">community amenities</a> add polish to everyday living. Have a question about pet guidelines? <a href=\"/contact-us\">Contact the leasing team</a> for current details.</p>",
  "property_referafriend_blurb": "<p><strong>Share your front row to Uptown Seattle.</strong> Love the skyline views, light-filled layouts, rooftop Skyview Terrace, and easy city connections at 110 Royy? Invite a friend to discover the community you call home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at 110 Royy.</strong><br>Keep home running smoothly from one convenient place. Log in to pay rent, submit maintenance requests, and manage your account—then get back to skyline calm, smart-lock ease, and everything that makes life at 110 Royy feel connected.</p>",
  "property_reviews_blurb": "<p><strong>Resident feedback with a human touch.</strong> In reviews for 110 Royy, residents consistently point to attentive service, quick communication, and a well-maintained property as reasons their experience stands out. From leasing support to maintenance care, the team earns praise for being helpful, responsive, and easy to work with.</p><p>One resident says, “It is the team that really shines,” while another highlights the “professionalism, responsiveness, and care” they’ve experienced. You’ll also see appreciation for the beautiful community, walkable Uptown setting, and everyday convenience that make life at 110 Royy feel connected and effortless.</p>",
  "property_created_at": "1762986360464",
  "property_scheduletour_blurb": "<p><strong>See Uptown from 110 Royy.</strong> Tour light-filled layouts with air conditioning, smart-lock entry, in-home laundry, and chef-style kitchens, then head up to the Skyview Terrace for Space Needle and skyline views. Schedule your visit and picture the city from here.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture life at 110 Royy: light-filled layouts, smart in-home finishes, and a rooftop Skyview Terrace with Space Needle and skyline views—all from a front-row Uptown Seattle address.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through the details before you arrive.</strong> Explore the available 2BR, 2BA apartment virtual tour at 110 Royy and get a closer look at the spaces that matter most: an open kitchen with a waterfall-edge island, light cabinetry, quartz countertops, stainless-steel appliances, and pendant lighting; a bright living area framed by expansive window walls; and two polished bathrooms with modern finishes.</p><p>Move at your own pace from room to room, checking the flow, natural light, storage, and everyday functionality from anywhere. When you are ready to compare this home with other layouts, visit <a href=\"/floor-plans\">floor plans</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience 110 Royy in Seattle in person.</p>",
  "property_copyright": "2026 All Rights Reserved. 110 Royy",
  "property_seo_title_home": "110 Royy |  Apartments in Seattle, WA",
  "property_seo_description_home": "Welcome to 110 Royy in Lower Queen Anne! Enjoy stunning skyline views, modern amenities, and vibrant nightlife. Find your perfect home today!",
  "property_seo_title_floorplans": "Floor Plans | Seattle, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect sanctuary at 110 Royy in Seattle! From cozy studios to spacious two-bedroom layouts, explore our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Seattle, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience urban living at 110 Royy! Enjoy breathtaking skyline views, modern amenities, and prime access to Seattle's culture. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Seattle, WA",
  "property_seo_description_gallery": "Imagine unwinding at 110 Royy in Seattle! Stylish studios to spacious 2-bedrooms, rooftop views, and vibrant nightlife—your urban oasis awaits. 📸",
  "property_seo_title_virtualtours": "Virtual Tours | 110 Royy Apartments",
  "property_seo_description_virtualtours": "Experience Seattle living at 110 Royy—take a virtual tour to explore our stunning studio, one, and two-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | 110 Royy Apartments",
  "property_seo_description_interactivemap": "Discover your perfect apartment at 110 Royy in Seattle! Use our interactive map to explore studio, one-, and two-bedroom layouts near Lower Queen Anne.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Seattle, WA",
  "property_seo_description_neighborhood": "Uncover Seattle's charm at 110 Royy! Dive into vibrant neighborhoods, trending local spots, and hidden gems just steps from your new home.",
  "property_seo_title_contact": "Contact Us | 110 Royy",
  "property_seo_description_contact": "Reach out to the 110 Royy team in Seattle, WA! Whether you’re curious about studio or two-bedroom plans, we're here to assist. Connect with us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Seattle, WA",
  "property_seo_description_faqs": "Explore 110 Royy in Seattle! Our FAQs page offers insights on amenities and floor plans for your future home in Lower Queen Anne.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Seattle, WA",
  "property_seo_description_reviews": "Join the vibrant 110 Royy community in Lower Queen Anne! See what residents love about our luxe amenities, skyline views, and unbeatable Seattle location.",
  "property_seo_title_applynow": "Apply Now | Apartments in Seattle, WA",
  "property_seo_description_applynow": "Step into luxury at 110 Royy in Lower Queen Anne! Enjoy stunning skyline views, modern amenities, and vibrant nightlife. Apply now and elevate your lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | 110 Royy",
  "property_seo_description_residentaccess": "Unlock the convenience of 110 Royy! Log in to your resident portal for easy rent payments, maintenance requests, and essential community updates.",
  "property_seo_title_referafriend": "Refer A Friend | 110 Royy",
  "property_seo_description_referafriend": "Refer a friend to 110 Royy in Seattle! Great friends make great neighbors—help your pals discover a vibrant community they’ll love calling home.",
  "property_seo_title_scheduletour": "Schedule a Tour | 110 Royy",
  "property_seo_description_scheduletour": "Experience urban living at 110 Royy in Seattle! Immerse yourself in stylish apartments and vibrant community life. Schedule your tour today!",
  "property_seo_title_privacy": "Privacy Policy | 110 Royy",
  "property_seo_description_privacy": "Your privacy matters at 110 Royy in Seattle. Read our policy to understand how we protect your personal information and ensure a safe living experience.",
  "property_seo_title_accessibility": "test",
  "property_seo_description_accessibility": "At 110 Royy in Seattle, we prioritize digital inclusion, ensuring everyone can access our community. Explore our commitment to accessibility for all!",
  "property_seo_title_sitemap": "Sitemap | 110 Royy",
  "property_seo_description_sitemap": "Navigate your way to your dream home at 110 Royy in Seattle, WA. Check out our sitemap for easy access to all the amenities and living options available!",
  "property_seo_title_thankyou": "Thank You | 110 Royy",
  "property_seo_description_thankyou": "Thank you for reaching out to 110 Royy in Seattle! Our team will connect soon to help you find your ideal home in our vibrant community. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Seattle, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791391688870",
  "amenities": [
    {
      "id": "custom_2350cce3-cc47-4f61-a0cc-02da37bac4fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Perfectly placed in Lower Queen Anne surrounded by entertainment, shopping, restaurants, and nightlife",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cae5a499-3808-46a8-97c3-42593affbc77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Rooftop Skyview Terrace with expansive skyline views, fire pit, grilling and lounge areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99fd8d42-e35a-44cb-94e1-5bda1a2aa5e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Fitness Studio",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ac676bf-58d6-4f89-a819-e5342b43d076",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Lounge with private work-from-home spaces, pool table, television, and entertainment style seating",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b0122d3-ea91-4a37-8cd8-8011ff3c28d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Free WiFi available in all common areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0817d1f7-a45c-4e83-959f-c49b9d0f9d56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Video entry system with remote access capability",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_944836f2-e883-487b-b605-e98f997d33ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled access garage with guest parking and EV charging",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_afd442d5-25a7-46aa-8105-22a15b93ebe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Secured access package lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a825f3f-13f5-4b76-a9d5-22d970b7dec8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Residential and bike storage with repair station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4fccda0-9062-4bdd-9d84-677ca711e130",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Designated rooftop pet area and self‑service Pet Spaw",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b35d316c-8475-4241-b15d-4bac5e63613b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently located near Seattle Center, Climate Pledge Arena, South Lake Union, and downtown Seattle",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3efee343-f0c3-4660-89e4-56d2ee84d289",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Nearby access to bicycle trail along the Elliott Bay Waterfront and Myrtle Edwards Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f356b9e-88e4-424a-9d05-3c692634dd64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Close to bus lines and other public transportation options",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d311142-599d-48cd-91ba-d664e40ea674",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Avenue5's resident rewards program is powered by Bilt, allowing us to offer our residents rewards at home and in the neighborhood. Click here to learn more!",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8afafd64-8b4b-42aa-b074-8bac7a5fc48d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Large selection of layouts: studio, open 1 bedroom, 1 bedroom, 1 bedroom + den, 2 bedrooms, and 2 bedroom + den",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b7f9f0c-a1d9-44c6-916a-53bbfdfd3815",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Incredible views of the Seattle skyline and iconic Space Needle*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9dcee422-3b0c-4d57-89f9-7b718b809a5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Chef style kitchen featuring premium stainless‑steel appliances, quartz slab countertops with full‑height tile backsplash, and multifunction pull‑out kitchen faucet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21ce57d0-0977-4e24-957a-9d14e3abeef1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Air conditioning in every home",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_947130c4-e634-43b3-b35d-1d8b8268cee1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Contemporary cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d524c9f-ad88-40af-a820-df1e1d8bd9ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑capacity front‑loading washer and dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dbfe77f4-dcfb-4f3e-9d71-b17135d3f988",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "High end hardwood‑style plank flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b63fa7de-3459-413d-89dd-43846d334478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Primary bedroom with spacious designer walk‑in closet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b6ca2d5-4359-43db-b7d3-5e9b2cb9d215",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive light‑filled windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_06454821-be63-44b0-bd6c-8b886dbd2231",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Biometric built‑in wall safe",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_688220f1-a2ff-4f66-81de-9eef60613445",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Smart Lock door technology with remote access capability",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c247ad3d-3412-4633-8532-f692c9677b2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Private balconies in most homes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c047a58-4e0f-488e-9972-2bb927472c51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Large terraces and patios*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c91b53f9-9319-4bd5-8fe4-88f640788d5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "external_id": "false",
      "title": "Extra high ceilings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b65269a8-05f5-42dc-8850-9fb5d43d054f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-0fc1-770c-9cc3-fc9123e1cb08.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer stacked in a closet.",
        "public_id": "019cfde5-0fc1-770c-9cc3-fc9123e1cb08",
        "storage_key": "property/6767906449166921/019cfde5-0fc1-770c-9cc3-fc9123e1cb08.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Other",
      "description": "Convenient in-unit stacked washer and dryer for easy laundry access.",
      "link": "",
      "alt_text": "In-unit washer and dryer stacked in a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/a-d8b13NJok7SVhZ7CCh_vvokz7UGtGt5gNmuVqry7Q/116/110-roy-apartments-seattle-wa-building-photo.jpg"
    },
    {
      "id": "custom_c3cf2ff4-4f7b-4b37-a260-638fd112889d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-100a-77ba-871d-44a28e681582.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a city view.",
        "public_id": "019cfde5-100a-77ba-871d-44a28e681582",
        "storage_key": "property/6767906449166921/019cfde5-100a-77ba-871d-44a28e681582.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Other",
      "description": "Cozy bedroom featuring a comfortable king-size bed, stylish nightstands, and a breathtaking city view. Perfect for relaxation and enjoying urban living.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a city view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lY3arIRE4zGXo8RiKnSE3ZBEdpLaCqBzXu7AXnHwJN4/116/110-roy-apartments-seattle-wa-building-photo.jpg"
    },
    {
      "id": "custom_fdff8d3a-87a6-4df9-a742-ed2ff741ca74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-def9-7388-91d5-0e26fca48d61.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a bed, two nightstands, lamps, and a large window with city views.",
        "public_id": "019cfde3-def9-7388-91d5-0e26fca48d61",
        "storage_key": "property/6767906449166921/019cfde3-def9-7388-91d5-0e26fca48d61.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright contemporary bedroom in an urban apartment with panoramic windows and cityscape views.",
      "link": "",
      "alt_text": "Bedroom in a modern apartment with a bed, two nightstands, lamps, and a large window with city views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2F7594167a20c37d5d8d1cad83049ce707.jpg"
    },
    {
      "id": "custom_8912cf7d-9bd4-4076-9d36-81914c9f9128",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-8c97-74da-bb38-b346220dc467.webp",
      "image_media": {
        "alt_text": "Modern apartment living room with a blue sofa, fireplace, and built-in shelving.",
        "public_id": "019cfde2-8c97-74da-bb38-b346220dc467",
        "storage_key": "property/6767906449166921/019cfde2-8c97-74da-bb38-b346220dc467.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Stylish open-concept living area with a contemporary fireplace, media wall, and decorative shelving—ideal for entertaining.",
      "link": "",
      "alt_text": "Modern apartment living room with a blue sofa, fireplace, and built-in shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2F708b771ab77db451210e2a4105c172ad.jpg"
    },
    {
      "id": "custom_8786e9fd-21bc-48b9-9404-f1f59755e23d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-c1b6-7106-b3b5-28dbea484628.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen in a modern apartment with city-view windows.",
        "public_id": "019cfde2-c1b6-7106-b3b5-28dbea484628",
        "storage_key": "property/6767906449166921/019cfde2-c1b6-7106-b3b5-28dbea484628.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Bright, modern apartment interior with a kitchen island, wood cabinets, and expansive city views.",
      "link": "",
      "alt_text": "Open-concept living room and kitchen in a modern apartment with city-view windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2Fc73ce5b4998ce0e50452074b107d5cf9.jpg"
    },
    {
      "id": "custom_e350e4de-eb42-4fcc-80c9-b0e69d0a24e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-0fd9-77eb-ab1a-7097718d37ea.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, dumbbells, and city skyline mural.",
        "public_id": "019cfde5-0fd9-77eb-ab1a-7097718d37ea",
        "storage_key": "property/6767906449166921/019cfde5-0fd9-77eb-ab1a-7097718d37ea.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Other",
      "description": "State-of-the-art fitness center featuring weight racks, dumbbells, and a vibrant city skyline mural.",
      "link": "",
      "alt_text": "Gym with weight racks, dumbbells, and city skyline mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FZ-tYlNEQIE0HHNR138iK69ZGICWD3SkDDZ95Es0IFI/116/110-roy-apartments-seattle-wa-building-photo.jpg"
    },
    {
      "id": "custom_0cfffb19-172b-4303-8b4c-b6a5185c23b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-c1b6-7106-b3b5-28dbea484628.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with island and large windows offering city skyline views.",
        "public_id": "019cfde2-c1b6-7106-b3b5-28dbea484628",
        "storage_key": "property/6767906449166921/019cfde2-c1b6-7106-b3b5-28dbea484628.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Modern apartment interior featuring a bright open kitchen with white countertops, dark wood cabinets, and cityscape views.",
      "link": "",
      "alt_text": "Open-concept kitchen with island and large windows offering city skyline views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/temporary-image-gallery/5767906449162273%2F6767906449166921%2Fc73ce5b4998ce0e50452074b107d5cf9.jpg"
    },
    {
      "id": "custom_bc4b4142-1417-4c09-8a85-3e54c8fde697",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-cd7f-7027-88fa-0cc91f5c5c08.webp",
      "image_media": {
        "alt_text": "Bright living room in a modern apartment with large windows and a curved white sofa.",
        "public_id": "019cfde2-cd7f-7027-88fa-0cc91f5c5c08",
        "storage_key": "property/6767906449166921/019cfde2-cd7f-7027-88fa-0cc91f5c5c08.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "A stylish living room in a modern apartment showcasing city views, soft tones, and contemporary furnishings.",
      "link": "",
      "alt_text": "Bright living room in a modern apartment with large windows and a curved white sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/temporary-image-gallery/5767906449162273%2F6767906449166921%2Ff6a8fe73b15217071075425ab2aeb9cb.jpg"
    },
    {
      "id": "custom_42371ccb-0937-4975-9d20-ca007d5b13ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-deef-75b8-95a2-b432dc0662e6.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with glass-enclosed shower, white countertop, and dark wood vanity.",
        "public_id": "019cfde3-deef-75b8-95a2-b432dc0662e6",
        "storage_key": "property/6767906449166921/019cfde3-deef-75b8-95a2-b432dc0662e6.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment bathroom with a glass shower, white counter, and a dark wood vanity with ample storage.",
      "link": "",
      "alt_text": "Modern apartment bathroom with glass-enclosed shower, white countertop, and dark wood vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2Fb7adaf8ee93483ff613ca4baea867088.jpg"
    },
    {
      "id": "custom_1329e5cf-1a21-486a-88bc-ec30cb5d0436",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-ea03-773e-9353-bcc2872777fe.webp",
      "image_media": {
        "alt_text": "Modern apartment community lobby with blue accent wall, fireplace, shelves, and seating.",
        "public_id": "019cfde3-ea03-773e-9353-bcc2872777fe",
        "storage_key": "property/6767906449166921/019cfde3-ea03-773e-9353-bcc2872777fe.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Contemporary lobby with a fireplace, artwork, and stylish seating for residents and guests.",
      "link": "",
      "alt_text": "Modern apartment community lobby with blue accent wall, fireplace, shelves, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2F9cd8b9135357a3c0c0b924c5ea8ef107.jpg"
    },
    {
      "id": "custom_94dc1a04-0ad6-4ce0-b162-0e94616d244f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-0fd9-77eb-ab1a-7097718d37ea.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, dumbbells, and city skyline mural.",
        "public_id": "019cfde5-0fd9-77eb-ab1a-7097718d37ea",
        "storage_key": "property/6767906449166921/019cfde5-0fd9-77eb-ab1a-7097718d37ea.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring weight racks, dumbbells, and a vibrant city skyline mural.",
      "link": "",
      "alt_text": "Gym with weight racks, dumbbells, and city skyline mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_abbc8bbd-0e9f-4692-a20a-94b52ddcda19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Din Tai Fung",
      "poi_type": "Restaurants",
      "poi_address": "600 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Relaxed Taiwanese chain featuring hand-pulled noodles, xiaolongbao dumplings and other regional dishes.",
      "poi_long_description": "People say this Taiwanese restaurant serves delicious soup dumplings, spicy wontons, and chocolate dumplings. They highlight the affordable prices, family-style dining, and tasty garlic green beans. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-ff54-778a-9c9c-3167a941b663.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-ff54-778a-9c9c-3167a941b663",
        "storage_key": "property/6767906449166921/019cfde3-ff54-778a-9c9c-3167a941b663.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dtf.com/en/locations/seattle-pacific-place",
      "poi_directions_map_url": "https://maps.google.com/?cid=4829861873643955218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung",
      "poi_latitude": "47.6126501",
      "poi_longitude": "-122.335168",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-682-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPemT0bRqkFQREiTAzMgdB0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fd1cfb60-4550-436d-b959-52aa7b029298",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "1200 E Pike St Suite No. 2, Seattle, WA 98122, USA",
      "poi_short_description": "Nashville-style chicken shop serving tenders, burgers, sliders and milkshakes.",
      "poi_long_description": "People say this chicken restaurant serves delicious, juicy, and crispy chicken sliders, tenders, and sandwiches with a variety of spice levels. They highlight the reasonable prices, generous portions, and fun, energetic vibe. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-ff4f-764c-b0a5-44921e9b0aa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-ff4f-764c-b0a5-44921e9b0aa8",
        "storage_key": "property/6767906449166921/019cfde3-ff4f-764c-b0a5-44921e9b0aa8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4892726209442789638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "47.6142778",
      "poi_longitude": "-122.3165507",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-813-2924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJic7fXWVrkFQRBrkUkZB05kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e4ab9449-2d07-4851-97bb-b5952485854f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "The Pink Door",
      "poi_type": "Restaurants",
      "poi_address": "1919 Post Alley, Seattle, WA 98101, USA",
      "poi_short_description": "Italian restaurant with cabaret shows and trapeze entertainment, plus terrace with Elliott Bay views.",
      "poi_long_description": "People say this Italian restaurant serves delicious arancini, cioppino, and squid ink pasta. They highlight the fresh seafood, flavorful sauces, and generous portions. They also like the attentive staff, lively atmosphere, and live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-57b1-75a9-ae0e-38b7234b71a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-57b1-75a9-ae0e-38b7234b71a7",
        "storage_key": "property/6767906449166921/019cfde3-57b1-75a9-ae0e-38b7234b71a7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thepinkdoor.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13451524338311652394&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-pink-door",
      "poi_latitude": "47.6103652",
      "poi_longitude": "-122.3425604",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-443-3241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91YOzrJqkFQRKmSW0B1qrbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_3d45f672-8566-4602-bc5e-a0bbb0f33016",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Von's 1000Spirits",
      "poi_type": "Restaurants",
      "poi_address": "1225 1st Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Casual dining on burgers, pizza & bar food in a tavern space showcasing a massive booze selection.",
      "poi_long_description": "People say this American restaurant serves delicious sourdough pasta, pizza, and bang bang chicken. They highlight the fun, lively atmosphere, and the extensive selection of spirits and cocktails. They also like the attentive and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-ff4e-7060-941e-5dd91b9a6737.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-ff4e-7060-941e-5dd91b9a6737",
        "storage_key": "property/6767906449166921/019cfde3-ff4e-7060-941e-5dd91b9a6737.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.vons1000spirits.com/?utm_source=gmb&utm_medium=organic&utm_campaign=gmbpost",
      "poi_directions_map_url": "https://maps.google.com/?cid=5056199159300483347&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vons-1000spirits",
      "poi_latitude": "47.6066052",
      "poi_longitude": "-122.3384085",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-621-8667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSjPILJqkFQRE-m7s1g6K0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_efcf8e61-a208-4022-bfd7-a135047203a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Dick's Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "115 Broadway E, Seattle, WA 98102, USA",
      "poi_short_description": "Long-running fast-food chain with a cult following for its homemade fries, burgers & shakes.",
      "poi_long_description": "People say this fast food restaurant serves tasty burgers, cheeseburgers, and fresh-cut fries. They also highlight the affordable prices, quick service, and friendly staff.\n\nSome reviews mention the fries can be soggy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-00c6-70b9-ab1a-7d09c4ed981a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-00c6-70b9-ab1a-7d09c4ed981a",
        "storage_key": "property/6767906449166921/019cfde4-00c6-70b9-ab1a-7d09c4ed981a.webp",
        "width": 1280,
        "height": 912
      },
      "poi_business_url": "http://www.ddir.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17975972120156224243&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dicks-drive-in",
      "poi_latitude": "47.6193263",
      "poi_longitude": "-122.3212263",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-323-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cIFkjIVkFQR87o8Cmd7d_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_818a7e33-8df6-43bb-9792-8f70c25c293d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "University Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2623 NE University Village St, Seattle, WA 98105, USA",
      "poi_short_description": "Al fresco shopping center since the 1950s, with local stores, well-known brands & dining options.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and a grocery store. They highlight the fun, walkable, and safe atmosphere, as well as the free parking and clean, well-maintained grounds. They also like the outdoor seating, umbrellas, and small playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-0407-7781-a3bb-edb7a2b3a803.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0407-7781-a3bb-edb7a2b3a803",
        "storage_key": "property/6767906449166921/019cfde4-0407-7781-a3bb-edb7a2b3a803.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://uvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185780485491805676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-village",
      "poi_latitude": "47.6616885",
      "poi_longitude": "-122.2990339",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-523-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3b03-70bd-99c4-7058c1f8e104",
        "storage_key": "property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2_IcB4YUkFQR7E2AoSzhFjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6a80aea7-6fab-496e-9f34-482b413de07b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2210 Westlake Ave N, Seattle, WA 98121, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, delicious baked goods, and a great salad bar. They also highlight the friendly and helpful staff, the spacious and clean environment, and the convenient location with ample parking.\n\nSome reviews mention the prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-6cc8-75e0-aad6-313d3f6392d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-6cc8-75e0-aad6-313d3f6392d5",
        "storage_key": "property/6767906449166921/019cfde3-6cc8-75e0-aad6-313d3f6392d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westlake?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13331991485400734650&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6183573",
      "poi_longitude": "-122.3380162",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-621-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d170-770d-8088-88155c0d2342",
        "storage_key": "property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyz9g9EkVkFQRutvXu56_BLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b44889d3-a107-456c-bc8a-97912ae659fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Uwajimaya Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 5th Ave S, Seattle, WA 98104, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh seafood, produce, snacks, and Japanese food, including sushi and poke. They highlight the reasonable portions, fair prices, and the fun, clean, and well-organized atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-0472-76e0-b918-fe8a97cb632e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0472-76e0-b918-fe8a97cb632e",
        "storage_key": "property/6767906449166921/019cfde4-0472-76e0-b918-fe8a97cb632e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/seattle/?utm_source=localprofiles&utm_medium=organic&utm_content=seattle&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=18369564176154316475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-seattle",
      "poi_latitude": "47.5967467",
      "poi_longitude": "-122.3270506",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-624-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d170-770d-8088-88155c0d2342",
        "storage_key": "property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq9nX27xqkFQRu05rxkrN7f4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_c548815d-706c-4a73-a132-035397857828",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Northgate Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 NE Northgate Way, Seattle, WA 98125, USA",
      "poi_short_description": "Indoor shopping mall with department stores, a play area & a couple dozen eateries.",
      "poi_long_description": "People say this shopping center offers a variety of stores and is conveniently located near public transportation, a movie theater, and an ice rink. They also highlight the clean, well-lit, and secure environment, as well as the easy access by car, bus, and train.\n\nOther reviews mention construction can be ongoing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-055e-773b-aa86-f690fcb2cbfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-055e-773b-aa86-f690fcb2cbfa",
        "storage_key": "property/6767906449166921/019cfde4-055e-773b-aa86-f690fcb2cbfa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/northgate-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=7968531460125271769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northgate-station",
      "poi_latitude": "47.70612269999999",
      "poi_longitude": "-122.3258649",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-362-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3b03-70bd-99c4-7058c1f8e104",
        "storage_key": "property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn7o7cFYRkFQR2aZK1iTplW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9f962d37-6e6f-4e7a-baa0-311583fa80b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1700 E Madison St, Seattle, WA 98122, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of snacks, fresh produce, and unique items not found elsewhere. They highlight the reasonable prices, especially for organic options, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-062c-726e-b7b7-7760a69c6a62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-062c-726e-b7b7-7760a69c6a62",
        "storage_key": "property/6767906449166921/019cfde4-062c-726e-b7b7-7760a69c6a62.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/seattle/130/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5748370317872008118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.61582569999999",
      "poi_longitude": "-122.309937",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-322-7268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d170-770d-8088-88155c0d2342",
        "storage_key": "property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0M1ztNqkFQRtgspEllQxk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_408c8b76-4cb4-4302-a736-6acd3dea21a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Seattle Public Library - Central Library",
      "poi_type": "Education",
      "poi_address": "1000 4th Ave, Seattle, WA 98104, USA",
      "poi_short_description": "Dramatic, view-filled facility lending books, films & music, plus numerous public computers.",
      "poi_long_description": "Visitors say this public library offers a wide variety of books, computers, and study spaces, and they praise its stunning, modern architecture. They also highlight the friendly staff and the peaceful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-0921-72ef-9ec5-05e0a56a9479.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0921-72ef-9ec5-05e0a56a9479",
        "storage_key": "property/6767906449166921/019cfde4-0921-72ef-9ec5-05e0a56a9479.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spl.org/hours-and-locations/central-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=12943420815159197138&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-public-library---central-library",
      "poi_latitude": "47.6066621",
      "poi_longitude": "-122.3321837",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-386-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ55fLWVtBkFQR0v31eadEoLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_60b1894b-2429-4f44-8559-1b15f0aff97a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "University of Washington",
      "poi_type": "Education",
      "poi_address": "1410 NE Campus Pkwy, Seattle, WA 98195, USA",
      "poi_short_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_long_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-c6eb-73ed-8ac6-df682560a5ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-c6eb-73ed-8ac6-df682560a5ae",
        "storage_key": "property/6767906449166921/019cfde3-c6eb-73ed-8ac6-df682560a5ae.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.washington.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742862557588237219&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington",
      "poi_latitude": "47.65671709999999",
      "poi_longitude": "-122.3066181",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-543-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zWFnZIUkFQRoyu4AXksdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_307d6122-a7a7-4070-b3a0-8294f404f667",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Seattle Central College",
      "poi_type": "Education",
      "poi_address": "1701 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-8771-771d-9087-b3729f2f73dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-8771-771d-9087-b3729f2f73dd",
        "storage_key": "property/6767906449166921/019cfde3-8771-771d-9087-b3729f2f73dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://seattlecentral.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860090414231206236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-central-college",
      "poi_latitude": "47.6167229",
      "poi_longitude": "-122.3215965",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-934-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJScFRw8xqkFQRXDnUjTNcGtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5d036620-9e25-4a29-bae5-7506f7a0bea3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Seattle University",
      "poi_type": "Education",
      "poi_address": "901 12th Ave, Seattle, WA 98122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-0b7b-730b-8de3-2cc6c9444da9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0b7b-730b-8de3-2cc6c9444da9",
        "storage_key": "property/6767906449166921/019cfde4-0b7b-730b-8de3-2cc6c9444da9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattleu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887710188514951233&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-university",
      "poi_latitude": "47.6091765",
      "poi_longitude": "-122.3178465",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-296-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZv0y8hqkFQRQcB9L4Wi1EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fcea2435-78d7-4492-9339-8aca1b1bdb27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "North Seattle College",
      "poi_type": "Education",
      "poi_address": "9600 College Way N, Seattle, WA 98103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-0bbf-74ec-bd4e-092919b47cff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0bbf-74ec-bd4e-092919b47cff",
        "storage_key": "property/6767906449166921/019cfde4-0bbf-74ec-bd4e-092919b47cff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://northseattle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=404283079753513623&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-seattle-college",
      "poi_latitude": "47.6989479",
      "poi_longitude": "-122.3326717",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-934-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVWVdQEUkFQRl7porVFNnAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5a27145e-5bfd-4c19-ac36-130e71d0fd22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "T-Mobile Park",
      "poi_type": "Entertainment",
      "poi_address": "1250 1st Ave S, Seattle, WA 98134, USA",
      "poi_short_description": "Seattle Mariners' ballpark with city skyline views, lots of stadium eats & a retractable roof.",
      "poi_long_description": "People say this stadium offers exciting baseball games, concerts, and fireworks shows, with a retractable roof and views of the city skyline. They highlight the electric atmosphere, family-friendly vibe, and convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-0ba3-771a-98ca-345f42d8dfd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0ba3-771a-98ca-345f42d8dfd5",
        "storage_key": "property/6767906449166921/019cfde4-0ba3-771a-98ca-345f42d8dfd5.webp",
        "width": 1242,
        "height": 540
      },
      "poi_business_url": "http://seattle.mariners.mlb.com/sea/ballpark/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14337255265305820565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "t-mobile-park",
      "poi_latitude": "47.591472",
      "poi_longitude": "-122.3325832",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-346-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3cd8-716e-9111-64e1f434f00f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3cd8-716e-9111-64e1f434f00f",
        "storage_key": "property/6767906449166921/019cfde4-3cd8-716e-9111-64e1f434f00f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28RdUJ9qkFQRlf2mprMp-MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_c288a27d-bfbd-4262-b397-570cf02c56e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Climate Pledge Arena",
      "poi_type": "Entertainment",
      "poi_address": "334 1st Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_long_description": "People say this arena offers a wide variety of food and drink options, and the acoustics are excellent for concerts and hockey games. They highlight the clean facilities, comfortable seating, and great views from all seats. They also like the friendly and helpful staff, and the efficient crowd management.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-8db8-700a-8b42-c8b61db8b679.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-8db8-700a-8b42-c8b61db8b679",
        "storage_key": "property/6767906449166921/019cfde3-8db8-700a-8b42-c8b61db8b679.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://climatepledgearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998104634649095719&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "climate-pledge-arena",
      "poi_latitude": "47.62207129999999",
      "poi_longitude": "-122.3540714",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-752-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ046-cUQVkFQRJy7KU2evBN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d283fdd0-7f13-4c38-a986-52b939e9ad99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Lumen Field",
      "poi_type": "Entertainment",
      "poi_address": "800 Occidental Ave S, Seattle, WA 98134, USA",
      "poi_short_description": "Home of the Seahawks & Sounders, this 68,740-seat multipurpose stadium features skyline views.",
      "poi_long_description": "People say this stadium offers a fun and energetic atmosphere for sporting events and concerts, with a loud and passionate crowd. They highlight the beautiful design, clean facilities, and convenient access via light rail, as well as the friendly and helpful staff. They also like the wide variety of food and drink options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-0ffb-715a-b2f6-955390ee218c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0ffb-715a-b2f6-955390ee218c",
        "storage_key": "property/6767906449166921/019cfde4-0ffb-715a-b2f6-955390ee218c.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "http://www.lumenfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11976986007816512220&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lumen-field",
      "poi_latitude": "47.5951518",
      "poi_longitude": "-122.3316394",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-381-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3cd8-716e-9111-64e1f434f00f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3cd8-716e-9111-64e1f434f00f",
        "storage_key": "property/6767906449166921/019cfde4-3cd8-716e-9111-64e1f434f00f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKxjxuaNqkFQR3CK6O1HNNqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0422dde5-82fb-41e4-9801-14e69c669fc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Woodland Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "Seattle, WA 98103, USA",
      "poi_short_description": "92-acre zoo with nearly 300 species, a vintage carousel, summer concerts & an indoor play space.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including gorillas, hippos, and penguins, and features a historic carousel and a dinosaur exhibit. They highlight the natural paths, spacious enclosures, and the opportunity to see animals up close. They also like the family-friendly atmosphere and the annual membership option. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-10b4-742c-8ba2-6c051ee92f3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-10b4-742c-8ba2-6c051ee92f3d",
        "storage_key": "property/6767906449166921/019cfde4-10b4-742c-8ba2-6c051ee92f3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.zoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962776519554476210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-park-zoo",
      "poi_latitude": "47.668436",
      "poi_longitude": "-122.3508786",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-548-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydSuSkkUkFQRsqhB-cEtYnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_21d9b4c9-41ec-40b1-8cb8-430eee889026",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Seattle Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1483 Alaskan Way Pier 59, Seattle, WA 98101, USA",
      "poi_short_description": "Popular waterfront aquarium with interactive exhibits, a cafe & virtual reality shows.",
      "poi_long_description": "People say this aquarium offers a variety of marine life, including sea otters, seals, and an octopus, and features an underwater dome and touch tanks. They also highlight the friendly and knowledgeable staff, and the family-friendly atmosphere.\n\nSome reviews mention the admission can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-104d-7122-8dfc-554d8a2213dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-104d-7122-8dfc-554d8a2213dc",
        "storage_key": "property/6767906449166921/019cfde4-104d-7122-8dfc-554d8a2213dc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattleaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7753481524406941315&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-aquarium",
      "poi_latitude": "47.6074002",
      "poi_longitude": "-122.3429559",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-386-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ_oEiK1qkFQRg3bU4l3mmWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_0d84eb8b-88b0-465c-b1e0-db0ff7487bd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1416 NW Ballard Way, Seattle, WA 98107, USA",
      "poi_short_description": "Sporting gym with cardio equipment, free weights and an indoor pool (open year-round), plus a sauna.",
      "poi_long_description": "People say this gym offers a variety of equipment, a pool, and personal training options, and the staff is friendly and helpful.\n\nOther reviews mention the equipment can be broken and the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-11d1-72d6-88ab-fa6837e92ac8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-11d1-72d6-88ab-fa6837e92ac8",
        "storage_key": "property/6767906449166921/019cfde4-11d1-72d6-88ab-fa6837e92ac8.webp",
        "width": 1170,
        "height": 905
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=455&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3768693322368076231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.662302",
      "poi_longitude": "-122.3755124",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-508-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpfJWZLcVkFQRx8ki-5sWTTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_25dc91bd-ae85-4aec-8efd-69c9d4224499",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6416 Roosevelt Way NE, Seattle, WA 98115, USA",
      "poi_short_description": "",
      "poi_long_description": "Some gym goers say this gym is very clean and has friendly and helpful staff, and they appreciate the sauna and hot tub.\n\nOther reviews mention the gym can be crowded, and the wifi can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-15d9-74eb-a449-f5aa454ec4c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-15d9-74eb-a449-f5aa454ec4c5",
        "storage_key": "property/6767906449166921/019cfde4-15d9-74eb-a449-f5aa454ec4c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1334&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12116533433758221096&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.67557799999999",
      "poi_longitude": "-122.3172546",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-257-7687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ51_kt28UkFQRKINNPPaSJqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a0f9ba3f-5f70-48bc-99c5-92efa1443014",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1827 Yale Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Chain featuring squat racks, treadmills, weights, machines and locker rooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-1603-74f8-908e-45cb53c9fb54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1603-74f8-908e-45cb53c9fb54",
        "storage_key": "property/6767906449166921/019cfde4-1603-74f8-908e-45cb53c9fb54.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/seattle-wa/downtown-seattle-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=3594284804022718634&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.6180661",
      "poi_longitude": "-122.330962",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-624-0651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu5csWjQVkFQRqtBbZfx24TE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5d6f18fe-7e68-4c3b-8bde-ab157a9ec16d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Olympic Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 Leary Ave NW, Seattle, WA 98107, USA",
      "poi_short_description": "Elegant sports club with weights, cardio machines, group classes, an indoor pool, saunas & jacuzzis.",
      "poi_long_description": "Elegant sports club with weights, cardio machines, group classes, an indoor pool, saunas & jacuzzis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-1755-7466-b2b4-22490362053a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1755-7466-b2b4-22490362053a",
        "storage_key": "property/6767906449166921/019cfde4-1755-7466-b2b4-22490362053a.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://www.olympicathleticclub.com/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9243484350012506487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olympic-athletic-club",
      "poi_latitude": "47.6664152",
      "poi_longitude": "-122.3828324",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-944-3615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-6exLYVkFQRd8Fg0Qp0R4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1efa0a22-1931-45f0-8301-f6bc5ede90a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3900 SW Alaska St, Seattle, WA 98116, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of equipment, a sauna, and a hot tub.\n\nOther reviews mention the facilities can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-1721-7078-b621-b9be425e541a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1721-7078-b621-b9be425e541a",
        "storage_key": "property/6767906449166921/019cfde4-1721-7078-b621-b9be425e541a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=933&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=28139852350169835&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.5621105",
      "poi_longitude": "-122.3818632",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-582-0888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj2hgw_hAkFQR6yJd7wv5YwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2bab4960-b688-4b7b-aa73-a0ef66e41284",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "507 NE Northgate Way, Seattle, WA 98125, USA",
      "poi_short_description": "Chain fitness center featuring a pool, cardio machines and personal trainers as well as basketball courts.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including a basketball gym, free weights, machines, a group exercise room, a pool, a hot tub, a sauna, and a steam room, and provides several classes throughout the day.\n\nOther reviews mention the gym can be crowded and some machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-1a6c-719c-a31c-2b14aa72bc0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1a6c-719c-a31c-2b14aa72bc0c",
        "storage_key": "property/6767906449166921/019cfde4-1a6c-719c-a31c-2b14aa72bc0c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/seattle-wa/northgate-fifth-ave-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=5024363022030936683&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.7082989",
      "poi_longitude": "-122.3229892",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-368-2431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1rcAlcRkFQRaxrDXowfukU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a726698f-ab8d-4c0c-8f86-262c6a0f4723",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Equinox Rainier Square",
      "poi_type": "Health and Wellness",
      "poi_address": "401 Union St Suite 220, Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of classes, top-tier equipment, and luxurious amenities, including spacious locker rooms with steam rooms.\n\nOther reviews mention the weightlifting area can be small and the parking can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-1aa1-76af-930a-4e213ac8de5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1aa1-76af-930a-4e213ac8de5d",
        "storage_key": "property/6767906449166921/019cfde4-1aa1-76af-930a-4e213ac8de5d.webp",
        "width": 265,
        "height": 265
      },
      "poi_business_url": "https://equinox-spa.com/serviceGroupDetails?facilityId=790&cid=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3460855741733625954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "equinox-rainier-square",
      "poi_latitude": "47.6092692",
      "poi_longitude": "-122.335354",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-336-0260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5aexv1rkFQRYmDn8PVtBzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ca3a8626-3cf4-4699-8388-fbb96a8409db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 NW Market St Ste 100, Seattle, WA 98107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-1c4c-765e-8862-3efce3cc3737.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1c4c-765e-8862-3efce3cc3737",
        "storage_key": "property/6767906449166921/019cfde4-1c4c-765e-8862-3efce3cc3737.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18000937299387102910&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.668813",
      "poi_longitude": "-122.3773675",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-260-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1WjAVG8VkFQRvjYMyhkt0Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_af4f3d0c-5718-4134-a702-d0107d82bd60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Barry's Seattle",
      "poi_type": "Health and Wellness",
      "poi_address": "112 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Chains for group training in the Red Room on treadmills, interspersed with bench exercises.",
      "poi_long_description": "People say this fitness center offers a great workout with fun music and easy-to-follow instructions. They highlight the high-energy, positive vibe and the empowering and welcoming atmosphere. They also like the motivating and encouraging coaching. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-1d0e-742c-afd4-8a277d8c4717.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1d0e-742c-afd4-8a277d8c4717",
        "storage_key": "property/6767906449166921/019cfde4-1d0e-742c-afd4-8a277d8c4717.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.barrys.com/studio/seattle",
      "poi_directions_map_url": "https://maps.google.com/?cid=1874324567168923080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barrys-seattle",
      "poi_latitude": "47.6188612",
      "poi_longitude": "-122.3382048",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-687-7180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8epeK8VkFQRyDXkY0PwAho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_4620e0c7-d6e4-4695-96cb-8473556d4b99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "West Seattle Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2629 SW Andover St, Seattle, WA 98126, USA",
      "poi_short_description": "Swimming, spacious gym featuring a rock-climbing wall and a heated pool.",
      "poi_long_description": "People say this fitness center offers a wide variety of amenities, including a pool, sauna, and jacuzzi, as well as numerous classes and workout equipment. They also highlight the friendly and helpful staff, and the clean and comfortable facilities.\n\nSome reviews mention the machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-1f0b-725e-96d7-2ddcba1fbf3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1f0b-725e-96d7-2ddcba1fbf3f",
        "storage_key": "property/6767906449166921/019cfde4-1f0b-725e-96d7-2ddcba1fbf3f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://westseattlehc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17611443290596558280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-seattle-health-club",
      "poi_latitude": "47.5680479",
      "poi_longitude": "-122.3676256",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-556-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizEFLE7YB0ERyMXxBV1qaPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_36602250-baf8-4b48-8bb3-26fd9c2eb460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Seattle Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Sand Point Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-c6a3-751a-8f9d-62e1136ffc00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-c6a3-751a-8f9d-62e1136ffc00",
        "storage_key": "property/6767906449166921/019cfde3-c6a3-751a-8f9d-62e1136ffc00.webp",
        "width": 920,
        "height": 612
      },
      "poi_business_url": "https://www.seattlechildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535247879101277020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-childrens-hospital",
      "poi_latitude": "47.6628364",
      "poi_longitude": "-122.281996",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-987-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d555-773c-9cd4-25a192d54a59",
        "storage_key": "property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYx10YIUkFQRXOPoZdRuFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e5b93186-1809-47f2-981c-8db6ae7b6924",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Harborview Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-97d5-7264-aa8a-33860e0a8e48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-97d5-7264-aa8a-33860e0a8e48",
        "storage_key": "property/6767906449166921/019cfde3-97d5-7264-aa8a-33860e0a8e48.webp",
        "width": 1279,
        "height": 903
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/harborview-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6803544737971406536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harborview-medical-center",
      "poi_latitude": "47.6039167",
      "poi_longitude": "-122.323905",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-744-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d555-773c-9cd4-25a192d54a59",
        "storage_key": "property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w3EijcVkFQRyIZDeOQLa14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e964907f-8c4f-4e90-8e73-8b1bb694872b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Gas Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "Former site of an oil plant is now a 20-acre park with picnic facilities & dramatic city views.",
      "poi_long_description": "People say this city park offers stunning views of the Seattle skyline, Lake Union, and the Space Needle, and is a great spot for picnics, kite flying, and watching seaplanes. They highlight the park's unique blend of industrial history and natural beauty, with preserved gas plant structures and open green spaces. They also like the relaxed and romantic vibe, perfect for solo visits, dates, or outings with dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-232e-74cd-9d94-609295d8d296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-232e-74cd-9d94-609295d8d296",
        "storage_key": "property/6767906449166921/019cfde4-232e-74cd-9d94-609295d8d296.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/gas-works-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2192784265468010902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gas-works-park",
      "poi_latitude": "47.6456308",
      "poi_longitude": "-122.3343532",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7BbsgIVkFQRlmFJ7KtVbh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4469c629-1eb7-489a-a88b-0fe8ca71f6f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Kerry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "211 W Highland Dr, Seattle, WA 98119, USA",
      "poi_short_description": "Panoramic views of Downtown & the Space Needle draw visitors to this small neighborhood park.",
      "poi_long_description": "People say this city park offers stunning views of the Seattle skyline, Space Needle, and Mount Rainier, as well as the harbor and Puget Sound. They highlight the panoramic views, especially at sunset and night, and the opportunity to take photos. They also like the chill and relaxing vibe, and the availability of benches for enjoying the scenery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-aae1-702b-9265-e17bdccdb101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-aae1-702b-9265-e17bdccdb101",
        "storage_key": "property/6767906449166921/019cfde3-aae1-702b-9265-e17bdccdb101.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seattle.gov/parks/find/parks/kerry-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3744576093846549902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kerry-park",
      "poi_latitude": "47.6294692",
      "poi_longitude": "-122.3599224",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUS2ELmoVkFQRjrUkJB5o9zM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_12bc4b84-379e-4380-ab3a-8a9f700111bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Golden Gardens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8498 Seaview Pl NW, Seattle, WA 98117, USA",
      "poi_short_description": "City park draws outdoor lovers for Puget Sound & mountain views, trails & a dog off-leash area.",
      "poi_long_description": "People say this city park offers a sandy beach, volleyball courts, fire pits, and picnic areas with grills. They highlight the beautiful scenery, mountain views, and relaxing vibe, and like the free parking and dog-friendly areas. They also mention the park is a great place to watch the sunset.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-249b-7648-8c45-9f05ad014869.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-249b-7648-8c45-9f05ad014869",
        "storage_key": "property/6767906449166921/019cfde4-249b-7648-8c45-9f05ad014869.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/golden-gardens-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6569770599323732682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-gardens-park",
      "poi_latitude": "47.6917517",
      "poi_longitude": "-122.4030912",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72JgjmQWkFQRygp_TI2DLFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fa183b2c-08dd-45c7-b3c8-0e0d3af7040c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Seattle, WA 98199, USA",
      "poi_short_description": "Seattle's largest green space features miles of rugged trails & beaches, plus views of the Sound.",
      "poi_long_description": "People say this park offers scenic trails, a lighthouse, and a beach with views of the Puget Sound and mountains. They highlight the peaceful and serene vibe, and the opportunity for hiking, picnics, and dog-friendly walks. They also like the well-maintained trails and the availability of parking and public transportation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-25fe-75d0-bf5c-935d8bafa5c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-25fe-75d0-bf5c-935d8bafa5c7",
        "storage_key": "property/6767906449166921/019cfde4-25fe-75d0-bf5c-935d8bafa5c7.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/discovery-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5879522751650882336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "47.6613197",
      "poi_longitude": "-122.4171413",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0CO4fAVkFQRIGP6pMpCmFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b55598d9-e076-41fe-94df-ec0d3cf13fa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Olympic Sculpture Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2901 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "An offshoot of the Seattle Art Museum, this park features numerous sculptures spread over 9 acres.",
      "poi_long_description": "People say this park offers stunning views of the ocean, the Space Needle, and the Olympic Mountains, as well as a collection of sculptures. They highlight the peaceful and relaxing atmosphere, perfect for a leisurely stroll or a break from the city. They also like the well-maintained infrastructure and the ample space for picnics and relaxation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-af4f-749b-a0d7-e9d29d515140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-af4f-749b-a0d7-e9d29d515140",
        "storage_key": "property/6767906449166921/019cfde3-af4f-749b-a0d7-e9d29d515140.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.seattleartmuseum.org/visit/olympic-sculpture-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8934295156938678169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olympic-sculpture-park",
      "poi_latitude": "47.6166028",
      "poi_longitude": "-122.3553167",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-654-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc88dJ1AVkFQRmZ_S-xv-_Hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_72ffaf71-3902-47ed-80e3-58e922ce726c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Westlake",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-27a9-72a8-a92e-2d3355f3362f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-27a9-72a8-a92e-2d3355f3362f",
        "storage_key": "property/6767906449166921/019cfde4-27a9-72a8-a92e-2d3355f3362f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5693109731314450214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westlake",
      "poi_latitude": "47.61157",
      "poi_longitude": "-122.33672",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQyrwLRqkFQRJj9RIiP9AU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_d0ddf125-a409-4ac0-8354-edd3f4fd3b2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "U District",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this light rail station is clean and spacious. They highlight the station is well-lit and has security. They also like the changing art installations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-29b3-746f-bc9e-61292d0a9f8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-29b3-746f-bc9e-61292d0a9f8a",
        "storage_key": "property/6767906449166921/019cfde4-29b3-746f-bc9e-61292d0a9f8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/u-district-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=8874690119994055692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "u-district",
      "poi_latitude": "47.6599885",
      "poi_longitude": "-122.3140745",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93n1LIsUkFQRDBzq3aQ7KXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_3f580c09-1dcb-4ba8-84a0-ab2a0e250e8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "University of Washington Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-2b1c-767d-a677-c3f455e68b9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2b1c-767d-a677-c3f455e68b9b",
        "storage_key": "property/6767906449166921/019cfde4-2b1c-767d-a677-c3f455e68b9b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/university-washington-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042961121833481987&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-station",
      "poi_latitude": "47.65031",
      "poi_longitude": "-122.30374",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdBrZusUkFQRA3cRa4t5Zfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4e3bca83-618f-4281-a6eb-6bb9101cb637",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Symphony",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-2ca3-772e-afcd-3a69ba688b80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2ca3-772e-afcd-3a69ba688b80",
        "storage_key": "property/6767906449166921/019cfde4-2ca3-772e-afcd-3a69ba688b80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10052292521089458792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "symphony",
      "poi_latitude": "47.60781",
      "poi_longitude": "-122.33602",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRf6wbNqkFQRaGLa4cnqgIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_8989d8ed-1725-4d40-b03b-4af2e482cf26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Roosevelt",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-2d4a-7448-8973-57773c3add22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2d4a-7448-8973-57773c3add22",
        "storage_key": "property/6767906449166921/019cfde4-2d4a-7448-8973-57773c3add22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/roosevelt-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=5282645169596799289&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roosevelt",
      "poi_latitude": "47.67611000000001",
      "poi_longitude": "-122.31604",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1X3KKnAUkFQRORlACMu5T0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_26ed491e-edcd-4919-a1e4-03a423c0ea94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Amazon - Doppler",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2021 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-300c-7668-af31-5c1a93a9c8d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-300c-7668-af31-5c1a93a9c8d2",
        "storage_key": "property/6767906449166921/019cfde4-300c-7668-af31-5c1a93a9c8d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amazon.jobs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11285464150585336235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon---doppler",
      "poi_latitude": "47.6150245",
      "poi_longitude": "-122.338417",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-280-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubQpU0oVkFQRq2ELHdoFnpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cf349345-727a-43b0-9974-c5807a9544a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Amazon re:Invent",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2121 8th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3064-7404-aa89-993f3c466983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-3064-7404-aa89-993f3c466983",
        "storage_key": "property/6767906449166921/019cfde4-3064-7404-aa89-993f3c466983.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16622250602859019695&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-reinvent",
      "poi_latitude": "47.6167313",
      "poi_longitude": "-122.3386481",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfQ75DIVkFQRrz3v1toYruY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6bf62da3-0ad0-4856-a490-d907949513b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "The Spheres",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2111 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Ultramodern office building with lush botanical gardens, open for public tours by appointment.",
      "poi_long_description": "Ultramodern office building with lush botanical gardens, open for public tours by appointment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3320-75aa-bf80-50dbb111c9bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-3320-75aa-bf80-50dbb111c9bf",
        "storage_key": "property/6767906449166921/019cfde4-3320-75aa-bf80-50dbb111c9bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattlespheres.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9167585885114143500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-spheres",
      "poi_latitude": "47.615728",
      "poi_longitude": "-122.3395104",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsX8RyksVkFQRDBMdYsrOOX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4bb425b7-a74c-4ca1-81b9-dc9ec6d78a06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Amazon Nitro North",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2250 7th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3340-712b-8c44-bfd82e8ab76b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-3340-712b-8c44-bfd82e8ab76b",
        "storage_key": "property/6767906449166921/019cfde4-3340-712b-8c44-bfd82e8ab76b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=577859250656015239&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-nitro-north",
      "poi_latitude": "47.6174162",
      "poi_longitude": "-122.3408815",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-946-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBay75mUVkFQRh3OGRe33BAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_23298b17-e927-4b2b-9943-e901c916ec44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "poi_name": "Expedia Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1111 Expedia Group Wy W, Seattle, WA 98119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3680-723b-9264-5fe39232edd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-3680-723b-9264-5fe39232edd3",
        "storage_key": "property/6767906449166921/019cfde4-3680-723b-9264-5fe39232edd3.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://careers.expediagroup.com/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15469363506382453691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "expedia-group",
      "poi_latitude": "47.6288379",
      "poi_longitude": "-122.3756115",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-679-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZaBVEIhskFQRuztRGyY4rtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6f8272ad75169c4af6dea2df",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cc48f7302b49f034343503df",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8855c860ecc038c33d3eb605",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2843e29e1e8f039fffc2f4f0",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ecb611eebc2c2e288f475ce6",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2e8aa74da98bb372404e2684",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_54eb331eb4cdd866b1147449",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "SUN",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_5a2e16df-96ec-4294-a600-165a2a334d5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "rating": "5.0",
      "name": "Amy Thomas",
      "text": "My experience at 110 Roy has been exceptional. Beautiful property and well maintained!! It is the team that really shines. Nathalie made me feel at home as soon as I walked in the door for my tour and helped me find the perfect apartment. She is kind and thoughtful!! Blake has been quick to communicate and very helpful. I feel very lucky to have come across this building!! Neighborhood is also lovely, super walkable, and close to everything! I definitely recommend!",
      "date": "2025-09-17",
      "title": ""
    },
    {
      "id": "custom_4c55df8a-e0e2-4a83-949a-f79c59bf24c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "rating": "5.0",
      "name": "Zach Capozzi",
      "text": "I have lived at 110 Roy for a couple of months now and I cannot say enough great things about the entire staff, from leasing to maintenance. A special thank you to Blake, the maintenance supervisor, for the outstanding service he provides.\n\nI’ve lived in several apartment complexes over the years, and I can confidently say that I’ve never experienced such professionalism, responsiveness, and care from an apartment complex.",
      "date": "2025-08-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ed4ce762-13f6-4608-a21f-ba934a54e9dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019e6f99-d202-71e0-81e9-dfdf5765c99e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e6f99-d202-71e0-81e9-dfdf5765c99e",
        "storage_key": "property/6767906449166921/019e6f99-d202-71e0-81e9-dfdf5765c99e.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "2BR, 2BA - 1,158 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dQ8z1EnebY"
    },
    {
      "id": "custom_2d9aed0c-52d9-41b6-9768-729467bdd0c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a11742-b127-73cb-a43d-1aee75ce4a59.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Simple house icon",
        "public_id": "01a11742-b127-73cb-a43d-1aee75ce4a59",
        "storage_key": "property/6767906449166921/01a11742-b127-73cb-a43d-1aee75ce4a59.webp",
        "width": 50,
        "height": 50
      },
      "virtual_tour_title": "2BR, 2BA - 1,026SF [test]",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UZiEikAFS81"
    }
  ],
  "faqs": [
    {
      "id": "custom_37338551-094b-4f72-9840-c4ee48ab55ef",
      "question": "Are FAQs working?",
      "answer": "I hope so",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_f0329f69-afd3-42e5-b30c-c8d087e8c039",
      "question": "Can I add multiple?",
      "answer": "Yes",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_b598afa5-7a06-40a4-a67c-327483d49ea2",
      "question": "adding faq",
      "answer": "test",
      "category": "",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019c8c0a-2468-77af-9f66-ccf7d6f8728c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "sandbox-test-site",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921"
    },
    {
      "lead_collector_id": "019d63c9-260a-7259-b138-f2d02903e15b",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "page_item_url": "highrise-apartments-that-allow-bunnies-110-roy",
      "search_query": "highrise apartments that allow bunnies",
      "category": "",
      "h1_title": "Bunny-Friendly Highrise Apartments",
      "h2_subtitle": "Explore our highrise apartments that allow bunnies. No need to leave furry friends behind at 110 Roy!",
      "page_copy": "Embrace a pet-inclusive lifestyle at 110 Roy, where our highrise apartments that allow bunnies offer a welcoming environment. Located in the vibrant Lower Queen Anne area of Seattle, these homes feature spacious layouts with private balconies in most residences, perfect for accommodating small pets like bunnies. Our community extends its warmth to pets with convenient services that ensure comfort and care for all residents.\n\nInside 110 Roy, enjoy modern layouts ranging from studios to two-bedroom configurations, complete with high-end finishes. The on-site amenities, such as a rooftop terrace and 24-hour fitness studio, blend convenience with leisure. Plus, with controlled access and community-wide WiFi, you and your bunny friends will feel right at home. Discover the unique charm of our pet-friendly highrise today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-7895-70fe-bc42-46d10290ad0a.webp",
      "featured_image_media": {
        "alt_text": "Exterior aerial view of a modern apartment building with balconies and \"Now Open\" signs.",
        "public_id": "019cfde2-7895-70fe-bc42-46d10290ad0a",
        "storage_key": "property/6767906449166921/019cfde2-7895-70fe-bc42-46d10290ad0a.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bunny-Friendly Highrise Apartments in Seattle",
      "seo_description": "Find bunny-friendly highrise apartments at 110 Roy, Seattle. Spacious layouts and pet amenities await!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "page_item_url": "luxury-apartments-skyline-views-seattle-wa",
      "search_query": "luxury apartments with skyline views seattle wa",
      "category": "Amenity",
      "h1_title": "High Rise Apartments with Skyline Views",
      "h2_subtitle": "Experience the best of Seattle with luxury apartments featuring breathtaking skyline views. Discover upscale living in the heart of Seattle's Uptown neighborhood.",
      "page_copy": "Nestled within the vibrant Uptown neighborhood, 110 Roy offers luxury apartments with skyline views of Seattle, WA. These spacious homes captivate with expansive light-filled windows, providing a panoramic gateway to the city’s iconic skyline. At 110 Roy, you'll find thoughtfully designed living spaces featuring primary bedrooms with designer walk-in closets, ideal for elevating your everyday living. \n\nBeyond the comfort of your apartment, immerse yourself in exceptional amenities like a resident lounge equipped for both relaxation and productivity. With nearby access to the Elliott Bay Waterfront and Myrtle Edwards Park, outdoor enthusiasts will appreciate the accessible bicycle trail coupled with the urban sophistication these luxury apartments offer. Discover unparalleled views and luxury living at 110 Roy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-8c97-74da-bb38-b346220dc467.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with a blue sofa, armchairs, fireplace, and large windows.",
        "public_id": "019cfde2-8c97-74da-bb38-b346220dc467",
        "storage_key": "property/6767906449166921/019cfde2-8c97-74da-bb38-b346220dc467.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Skyline Views",
      "seo_description": "Discover luxury apartments with skyline views in Seattle, WA. Experience prime amenities and vibrant Uptown living at 110 Roy.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "page_item_url": "apartments-air-conditioning-uptown-seattle",
      "search_query": "apartments with air conditioning in uptown seattle",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning Uptown",
      "h2_subtitle": "Stay comfortable year-round in Uptown Seattle apartments with air conditioning. Discover the perfect blend of modern living and convenience at 110 Roy.",
      "page_copy": "Located in the heart of Seattle's vibrant Uptown neighborhood, 110 Roy is the perfect place for those seeking apartments with air conditioning. Enjoy modern comforts while staying cool during Seattle's warm summer months. Our thoughtfully designed units feature expansive, light‑filled windows, offering an inviting atmosphere in every room.\n\nYou'll also benefit from an array of amenities, including a resident lounge equipped with private work-from-home spaces and entertainment options like a pool table and television. The controlled access garage offers both guest parking and EV charging stations. With nearby access to the Elliot Bay Waterfront and Myrtle Edwards Park, enjoying the outdoors is as easy as stepping outside the door. Choose 110 Roy for an unparalleled living experience in Uptown Seattle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning Uptown",
      "seo_description": "Find apartments with air conditioning in Uptown Seattle. Enjoy modern comforts and excellent amenities at 110 Roy.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "page_item_url": "bunny-friendly-apartments-atlanta-ga",
      "search_query": "apartments that allow bunnies in atlanta georgia",
      "category": "false",
      "h1_title": "Bunny-Friendly Apartments in Atlanta, GA",
      "h2_subtitle": "Discover apartments that allow bunnies in Atlanta, Georgia. Enjoy a pet-friendly home with spacious layouts and welcoming amenities.",
      "page_copy": "Are you searching for bunny-friendly apartments in Atlanta, Georgia? Look no further than our welcoming community, designed with pet lovers in mind. Our homes feature expansive floor plans and pet services that ensure both you and your pet rabbit feel right at home. \n\nOur community offers access to secure package lockers and convenient transportation options, making it easy to explore all that Atlanta has to offer. With large terraces and a rooftop Skyview Terrace complete with grilling areas and a fire pit, you'll love spending time outdoors amidst stunning skyline views. Join a community that values pets as much as you do, and experience life with your bunny in a vibrant city setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-7895-70fe-bc42-46d10290ad0a.webp",
      "featured_image_media": {
        "alt_text": "Exterior aerial view of a modern apartment building with balconies and \"Now Open\" signs.",
        "public_id": "019cfde2-7895-70fe-bc42-46d10290ad0a",
        "storage_key": "property/6767906449166921/019cfde2-7895-70fe-bc42-46d10290ad0a.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bunny-Friendly Apartments in Atlanta, GA",
      "seo_description": "Discover Atlanta apartments that welcome bunnies. Enjoy pet-friendly living with spacious layouts and great amenities. Find your new home in Atlanta today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "page_item_url": "testing",
      "search_query": "",
      "category": "",
      "h1_title": "Bunny friendly",
      "h2_subtitle": "Discover friendly apartents",
      "page_copy": "Our community is very friendly",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Welcoem to Atlanta",
      "seo_description": "tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_test",
      "type": "STRING",
      "value": null
    }
  ],
  "custom_audioeye_site_id": "d6f1f26f-f71c-443b-beef-15b4c935b955",
  "custom_audioeye_site_hash": "eeda0b538190504097d58a7e4b055558"
};

export const generatedAt = '2026-10-14T15:27:30.049Z';
